import { createElement } from 'react';

import { editBox, view } from './TextFieldArea.less';

const limitValue = (onChange, limit) => e => {
  const inputStr = e.target.value;
  if (inputStr.length <= limit) {
    onChange(e.target.value);
  }
};

const TextFieldArea = ({
  editing,
  input,
  meta,
  localeMessage,
  formValues,
  hintLocale,
  viewStyle = {},
  rows,
  cols,
  limit,
  ...other
}) =>
  editing
    ? createElement('textarea', {
        className: editBox,
        name: input.name,
        value: input.value,
        placeholder: hintLocale && localeMessage(hintLocale),
        onChange: limit && !isNaN(limit) ? limitValue(input.onChange, limit) : input.onChange,
        style: viewStyle,
        rows: rows,
        cols: cols,
        ...other,
      })
    : createElement('div', { className: view, style: viewStyle }, input.value);

export default TextFieldArea;
